export let categoryAriaLabel = "Vn_Vc";
export let folderAriaLabel = "BtwrO";
export default {categoryAriaLabel,folderAriaLabel};